import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Collapse from '@material-ui/core/Collapse';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import LinkIcon from '@material-ui/icons/Link';
import ListOfCompany from '../../components/ListOfCompany';
import { instanceAxios } from '../../InstanceAxios';
import { getYears } from '../../utils/common';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import FilterIcon from '@material-ui/icons/FilterList';

function Tributos() {
  const useStyles = makeStyles((theme) => ({
    root: {
      overflow: 'auto',
      width: '100%',
    },
    paper: {
      position: 'absolute',
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      top: `50%`,
      left: `50%`,
      transform: `translate(-50%, -50%)`,
      width: '80%',
      height: '80%',
      overflow: 'auto',
    },
    loading: {
      marginLeft: '50%',
    },
    selectTipo: {
      width: 200,
    },
    modalAddTitle: {
      position: 'absolute',
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 2),
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
  }));

  const hoje = new Date();
  const [columns, setColumns] = useState([
    { id: 'empresa', label: 'Empresa', minWidth: 140, filterable: true },
    { id: 'cnpj', label: 'CNPJ', minWidth: 140, filterable: true },
    { id: 'tipo', label: 'Tipo', minWidth: 140, filterable: true },
    { id: 'arquivo', label: 'Arquivo', minWidth: 70, filterable: false },
  ]);
  const [meses, setMeses] = useState([
    { nome: 'JAN', valor: 1 },
    { nome: 'FEV', valor: 2 },
    { nome: 'MAR', valor: 3 },
    { nome: 'ABR', valor: 4 },
    { nome: 'MAI', valor: 5 },
    { nome: 'JUN', valor: 6 },
    { nome: 'JUL', valor: 7 },
    { nome: 'AGO', valor: 8 },
    { nome: 'SET', valor: 9 },
    { nome: 'OUT', valor: 10 },
    { nome: 'NOV', valor: 11 },
    { nome: 'DEZ', valor: 12 },
  ]);
  const [anos, setAnos] = useState(getYears(2020));
  const [openAlert, setOpenAlert] = useState(false);
  const [tipoAlert, setTipoAlert] = useState('');
  const [messageAlert, setMessageAlert] = useState('');
  const [ready, setReady] = useState(true);
  const [mes, setMes] = useState(hoje.getMonth() + 1);
  const [ano, setAno] = useState(hoje.getFullYear());
  const [cnpj, setCnpj] = useState('');
  const [empresa, setEmpresa] = useState('');
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
  const [filterText, setFilterText] = useState('');
  const [columnId, setColumnId] = useState('');
  const [idOrder, setIdOrder] = useState('');
  const [order, setOrder] = useState('asc');
  const [originalGuias, setOriginalGuias] = useState([]);

  const [guias, setGuias] = useState([]);

  useEffect(() => {
    const fetchGuias = async () => {
      await atualizarGuias(mes, ano, cnpj, page, limit);
    };

    fetchGuias();
  }, []);

  const clickAlert = () => {
    setOpenAlert(false);
    setTipoAlert('');
    setMessageAlert('');
  };

  const handleChangeMes = (event) => {
    setMes(event.target.value);
    atualizarGuias(event.target.value, ano, cnpj, page, limit);
  };

  const handleChangeAno = (event) => {
    setAno(event.target.value);
    atualizarGuias(mes, event.target.value, cnpj, page, limit);
  };

  const handleLimit = (event) => {
    setLimit(event.target.value);
    atualizarGuias(mes, ano, cnpj, page, event.target.value);
  };

  const handlePage = (event) => {
    setPage(event.target.value);
    atualizarGuias(mes, ano, cnpj, event.target.value, limit);
  };

  const atualizarGuias = async (m, a, c, p, l) => {
    console.log(m);
    console.log(a);
    console.log(c);
    console.log(p);
    console.log(l);
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/tron/guia?mes=${m}&ano=${a}&cnpj=${c}&page=${p}&limit=${l}`)
      .then((res) => {
        const rows = Array.isArray(res?.data?.rows) ? res.data.rows : [];

        console.log(res.data);
        setGuias(rows);
        setOriginalGuias(rows);
        setCount(res?.data?.count || 0);
        setReady(true);
      })
      .catch((err) => {
        console.log(err);
        setGuias([]);
        setCount(0);
        setReady(true);
      });
  };

  const getPdf = (base64) => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const file = new Blob([byteArray], { type: 'application/pdf;base64' });
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL);
  };

  const openModalFilter = (event, columnid) => {
    setFilterText('');
    const rect = event.target.getBoundingClientRect();
    setIsModalOpen(true);
    setModalPosition({ top: rect.top, left: rect.left });
    setColumnId(columnid);
  };

  const handleFilterTextChange = (event) => {
    setFilterText(event.target.value);
  };

  // Function to filter the table data
  const filterTable = () => {
    setIsModalOpen(false);

    const filteredDas = originalGuias.filter((item) => {
      const value = getValueColumnId(columnId, item);
      return (
        value &&
        value.toString().toLowerCase().includes(filterText.toLowerCase())
      );
    });
    // Update the table data with filtered data
    setGuias(filteredDas);
  };

  const getValueColumnId = (columnIdAux, rowData) => {
    columnIdAux = columnIdAux.replace(/"/g, '');

    const parts = columnIdAux.split('.');

    let result = null;
    for (let part of parts) {
      if (result === null) {
        // If result is null, assign the global object to result
        result = rowData[part];
      } else {
        // If result is not null, access the property
        result = result[part];
      }
    }
    return result;
  };

  const clearFilter = () => {
    setIsModalOpen(false);
    setFilterText('');
    setGuias(originalGuias);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleRequestSort = (property) => {
    const orderBy = property;

    if (idOrder === property && order === 'desc') {
      setOrder('asc');
    } else {
      setOrder('desc');
    }

    setIdOrder(orderBy);
  };

  const sortTable = (property) => {
    const isAsc = order === 'asc';
    const guiasOrdenadas = Array.isArray(guias) ? [...guias] : [];

    guiasOrdenadas.sort((a, b) => {
      let aValue = getValueColumnId(property, a);
      let bValue = getValueColumnId(property, b);
      // If the property is a string, convert to lowercase for case-insensitive sorting
      if (typeof aValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }
      if (aValue < bValue) {
        return isAsc ? -1 : 1;
      }
      if (aValue > bValue) {
        return isAsc ? 1 : -1;
      }
      return 0;
    });
    setGuias(guiasOrdenadas);
  };

  const classes = useStyles();
  return (
    <>
      <Modal
        open={isModalOpen}
        onClose={closeModal}
        style={{ top: modalPosition.top, left: modalPosition.left }}
      >
        <div
          style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '5px',
            width: '300px',
          }}
        >
          <TextField
            label="Filtrar"
            variant="outlined"
            value={filterText}
            onChange={handleFilterTextChange}
            fullWidth
          />
          <Button
            variant="contained"
            color="primary"
            onClick={filterTable}
            style={{ marginTop: '10px' }}
          >
            Filtrar
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={clearFilter}
            style={{ marginTop: '10px', marginLeft: '5px', width: 70 }}
          >
            Limpar
          </Button>
        </div>
      </Modal>
      <h1 style={{ textAlign: 'center' }}>GUIAS</h1>
      <Collapse in={openAlert}>
        <Alert severity={tipoAlert} onClick={clickAlert}>
          {messageAlert}
        </Alert>
      </Collapse>
      <Paper className={classes.root}>
        <Collapse in={ready === false}>
          <CircularProgress className={classes.loading} />
        </Collapse>
        <Collapse in={ready}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              padding: 10,
            }}
          >
            <Grid container>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <ListOfCompany
                  label="Empresa do Cliente *"
                  width="40%"
                  companySelect={empresa}
                  setCompanySelect={(nome) => setEmpresa(nome)}
                  setCnpj={(c) => {
                    setCnpj(c);
                    atualizarGuias(mes, ano, c, page, limit);
                  }}
                  assinantes
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div align="right">
                  <FormControl variant="outlined">
                    <InputLabel>Mês</InputLabel>
                    <Select value={mes} onChange={handleChangeMes} label="Mês">
                      {meses.map((m) => (
                        <MenuItem key={m.nome} value={m.valor}>
                          {m.nome}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl variant="outlined">
                    <InputLabel>Ano</InputLabel>
                    <Select value={ano} onChange={handleChangeAno} label="Ano">
                      {anos.map((a) => (
                        <MenuItem key={a.nome} value={a.valor}>
                          {a.nome}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </Grid>
            </Grid>
          </div>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <TableSortLabel
                        active={idOrder === column.id}
                        direction={idOrder === column.id ? order : 'asc'}
                        onClick={() => {
                          handleRequestSort(column.id);
                          setTimeout(() => {
                            sortTable(column.id);
                          }, 200);
                        }}
                      >
                        {column.label}
                      </TableSortLabel>

                      {column.filterable && (
                        <IconButton
                          style={{ marginLeft: -5 }}
                          onClick={(event) => openModalFilter(event, column.id)}
                          aria-label="filtra"
                        >
                          <FilterIcon style={{ width: 16, height: 16 }} />
                        </IconButton>
                      )}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {(Array.isArray(guias) ? guias : []).map((g, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row" align="center">
                      {g.Empresa ? g.Empresa.razao_social : ''}
                    </TableCell>
                    <TableCell component="th" scope="row" align="center">
                      {g.cnpj}
                    </TableCell>
                    <TableCell component="th" scope="row" align="center">
                      {g.TipoGuium ? g.TipoGuium.tipo : ''}
                    </TableCell>
                    <TableCell component="th" scope="row" align="center">
                      {g.arquivo ? (
                        <Tooltip title="Delete">
                          <IconButton
                            aria-label="delete"
                            onClick={() => getPdf(g.arquivo)}
                          >
                            <LinkIcon />
                          </IconButton>
                        </Tooltip>
                      ) : null}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={count}
            rowsPerPage={limit}
            page={page}
            onChangePage={handlePage}
            onChangeRowsPerPage={handleLimit}
          />
        </Collapse>
      </Paper>
    </>
  );
}

export default Tributos;
